function setCookie(cname, cvalue, exdays) {
	const d = new Date();
	d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
	let expires = "expires="+d.toUTCString();
	document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
	let name = cname + "=";
	let ca = document.cookie.split(';');
	for(let i = 0; i < ca.length; i++) {
		let c = ca[i];
		while (c.charAt(0) == ' ') {
			c = c.substring(1);
		}
		if (c.indexOf(name) == 0) {
			return c.substring(name.length, c.length);
		}
	}
	return "";
}

export default {
	user: null,
	logo_path: null,
	init() {
		const userStr = getCookie("user");
		if (userStr === "") {
			return;
		}
		this.user = JSON.parse(userStr);
		if ('company' in this.user && 'logo_path' in this.user.company) {
			this.logo_path = this.user.company.logo_path;
		}
	},
	login(user) {
		this.user = user;
		if ('company' in this.user && 'logo_path' in this.user.company) {
			this.logo_path = this.user.company.logo_path;
		}
		setCookie("user", JSON.stringify(user), 30);
	},
	logout() {
		fetch(`/api/logout`, {
			method: 'POST',
			headers: {
				accept: 'application/json',
				'content-type': 'application/json',
			},
		})
		.then((resp) => {
			setCookie("user", "", -1);
			this.user = null;
			this.logo_path = null;
		});
	}
};
